__turbopack_context__.v({
  "body": "KAaE5q_body",
  "body__content": "KAaE5q_body__content",
  "body__content--can-play": "KAaE5q_body__content--can-play",
  "body__content--placeholder": "KAaE5q_body__content--placeholder",
  "card": "KAaE5q_card",
  "overlay": "KAaE5q_overlay",
  "overlay__content": "KAaE5q_overlay__content",
  "shimmer": "KAaE5q_shimmer",
  "text-bar-sweep": "KAaE5q_text-bar-sweep",
  "title": "KAaE5q_title",
  "title--placeholder": "KAaE5q_title--placeholder",
});
